import React, { useState, useEffect } from "react";
import CenterWrapper from "../../components/CenterWrapper.jsx";
import ChatWidget from "../../components/ChatWidget";
import GeneralSetupTab from "../../components/GeneralSetupTab";
import useWindowSize from "../../hooks/useWindowSize";
import ChatWidgetModal from "../../components/ChatWidgetModal";
import ChatButton from "../../icons/ChatButton";

const Chatbot = () => {
  const windowSize = useWindowSize();

  const [showWidgetModal, setShowWidgetModal] = useState(false);

  const onCloseWidgetModal = () => {
    setShowWidgetModal(false);
  };

  useEffect(() => {
    if (windowSize?.width <= 640) {
      setShowWidgetModal(true);
    }
  }, [windowSize?.width]);

  return (
    <CenterWrapper>
      <GeneralSetupTab
        title={"Setup"}
        pageType={"setup"}
        activeTab={"chatbot"}
      />

      {windowSize?.width > 640 && <ChatWidget test />}

      {windowSize?.width <= 640 && (
        <>
          <ChatWidgetModal
            open={showWidgetModal}
            onClose={onCloseWidgetModal}
            test
          />

          <button
            type="button"
            className="fixed bottom-6 right-6"
            onClick={() => setShowWidgetModal(true)}
          >
            <ChatButton />
          </button>
        </>
      )}
    </CenterWrapper>
  );
};

export default Chatbot;
